import { h } from 'preact';
import SVGWrapper from '../../../../../../common/components/svg/SvgWrapper';

function StarActiveIcon({ height = 60, width = 60, color = 'white', ...props }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path d="m11.4446 3.76039c.2032-.49758.9078-.49758 1.111 0l2.1144 5.17828 5.5135.45024c.5289.04319.7455.70119.3457 1.05009l-4.2091 3.6726 1.2823 5.4757c.1219.5208-.447.9288-.9012.6462l-4.7011-2.9248-4.70114 2.9248c-.45416.2826-1.02311-.1254-.90115-.6462l1.28229-5.4757-4.20908-3.6726c-.39983-.3489-.18324-1.0069.34564-1.05009l5.51353-.45024z" fill={color} />
    </SVGWrapper>
  );
}

export default StarActiveIcon;
